import type { ReactNode } from 'react'
import { Outlet } from 'react-router-dom'
import useAuthStore from '@/store/useAuthStore'
import useGetCurrentUser from '@/services/api/auth/useGetCurrentUser'
import MarketingChoiceScreen from './MarketingChoiceScreen'

/**
 * Blocks every route it wraps with the consent screen while the API says
 * the user still has to choose (social sign-up). Rendered in place rather than
 * redirected, so no URL gets around it.
 */
export default function MarketingChoiceGate({
  children,
}: {
  children?: ReactNode
}) {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated)
  const { data: currentUser } = useGetCurrentUser(isAuthenticated)

  if (isAuthenticated && currentUser?.marketing_choice_required) {
    return <MarketingChoiceScreen />
  }

  return children ?? <Outlet />
}
